const preType = 'AUTH_';

export const AuthActionTypes = {
  GET_CLIENT_INFO: `${preType}GET_CLIENT_INFO`,
  SET_CLIENT_INFO: `${preType}SET_CLIENT_INFO`,
  GET_PROFILE_CLIENT_INFO: `${preType}GET_PROFILE_CLIENT_INFO`,
  SET_PROFILE_CLIENT_INFO: `${preType}SET_PROFILE_CLIENT_INFO`,
  SAVE_TOKEN: `${preType}SAVE_TOKEN`,
  SAVE_USER: `${preType}SAVE_USER`,
  CHECK_VERIFY_CODE: `${preType}CHECK_VERIFY_CODE`,
  SET_CONFIRM_LOADING: `${preType}SET_CONFIRM_LOADING`,
  SEND_VERIFICATION_CODE: `${preType}SEND_VERIFICATION_CODE`,
  SET_VALIDATION_CODE_LIFETIME: `${preType}SET_VALIDATION_CODE_LIFETIME`,
  SET_VALIDATION_CODE_LOADING: `${preType}SET_VALIDATION_CODE_LOADING`,
  SET_SHOW_INFO_LOADING: `${preType}SET_SHOW_INFO_LOADING`,
  LOGOUT: `${preType}LOGOUT`,
  SET_CLIENT_MOBILE: `${preType}SET_CLIENT_MOBILE`,
  SET_MOBILE_VALIDATION: `${preType}SET_MOBILE_VALIDATION`,
  SET_VALIDATION_CODE: `${preType}SET_VALIDATION_CODE`,
  SET_COUNT_DOWN_OVER: `${preType}SET_COUNT_DOWN_OVER`,
  SET_COUNT_DOWN_RESET: `${preType}SET_COUNT_DOWN_RESET`,
  SET_LOGIN_MODAL: `${preType}SET_LOGIN_MODAL`,
  SET_REDIRECT_ROUTE: `${preType}SET_REDIRECT_ROUTE`,
  SET_COMPLETE_PROFILE_MODAL: `${preType}SET_COMPLETE_PROFILE_MODAL`,
  SET_SUBMIT_LOADING: `${preType}SET_SUBMIT_LOADING`,
  SET_PROVINCES_LIST: `${preType}SET_PROVINCES_LIST`,
  GET_PROVINCES_LIST: `${preType}GET_PROVINCES_LIST`,
  EDIT_CLIENT_INFO: `${preType}EDIT_CLIENT_INFO`,
  SET_PROFILE_INFO: `${preType}SET_PROFILE_INFO`,
  SET_INITIAL_STATE: `${preType}SET_INITIAL_STATE`,
  SET_FIRST_NAME: `${preType}SET_FIRST_NAME`,
  SET_LAST_NAME: `${preType}SET_LAST_NAME`,
  SET_NATIONAL_ID: `${preType}SET_NATIONAL_ID`,
  SET_SEX: `${preType}SET_SEX`,
  CHECK_INFO_VALIDATION: `${preType}CHECK_INFO_VALIDATION`,
  SET_HAS_CALLBACK_FUNCTION: `${preType}SET_HAS_CALLBACK_FUNCTION`,
  CHECK_SMS_CODE_AND_LOGIN: `${preType}CHECK_SMS_CODE_AND_LOGIN`,
  COMPLETE_CLIENT_PROFILE: `${preType}COMPLETE_CLIENT_PROFILE`,
};

const saveToken = (data: { accessToken: string, tokenType: string }) => ({ type: AuthActionTypes.SAVE_TOKEN, data: data });
const saveUser = (data: { firstName: string | null, lastName: string | null, phoneNumber: string }) => ({ type: AuthActionTypes.SAVE_USER, data: data });
const getClientInfo = (data: { token?: string | boolean }) => ({ type: AuthActionTypes.GET_CLIENT_INFO, data: data });
const checkVerifyCode = () => ({ type: AuthActionTypes.CHECK_VERIFY_CODE });
const sendVerificationCode = (data: {type: string, isRetryingToGetNewCode: boolean, token: string}) => ({ type: AuthActionTypes.SEND_VERIFICATION_CODE, data: data });
const logout = () => ({ type: AuthActionTypes.LOGOUT });
const setClientMobile = (data: { phoneNumber: string }) => ({ type: AuthActionTypes.SET_CLIENT_MOBILE, data: data });
const setMobileValidation = (data: { isNumberValid: boolean }) => ({ type: AuthActionTypes.SET_MOBILE_VALIDATION, data: data });
const setValidationCode = (data: { verifyCode: string }) => ({ type: AuthActionTypes.SET_VALIDATION_CODE, data: data });
const setCountDownOver = () => ({ type: AuthActionTypes.SET_COUNT_DOWN_OVER });
const setCountDownReset = () => ({ type: AuthActionTypes.SET_COUNT_DOWN_RESET });
const setLoginModal = (data: { loginModal: boolean, callBackTypeId?: string, redirectRoute?: string, hasCallbackFunction?: boolean, hasCostumeVerify?: boolean }) => ({ type: AuthActionTypes.SET_LOGIN_MODAL, data: data });
const setRedirectRoute = (data: { redirectRoute: string | undefined }) => ({ type: AuthActionTypes.SET_REDIRECT_ROUTE, data: data });
const setCompleteProfileModal = (data: { completeProfileModal: boolean }) => ({ type: AuthActionTypes.SET_COMPLETE_PROFILE_MODAL, data: data });
const setConfirmLoading = (data: { confirmLoading: boolean }) => ({ type: AuthActionTypes.SET_CONFIRM_LOADING, data: data });
const editClientProfile = () => ({ type: AuthActionTypes.EDIT_CLIENT_INFO });
const getProvincesList = () => ({ type: AuthActionTypes.GET_PROVINCES_LIST });
const setProfileInfo = (data: { info: string, key: string }) => ({ type: AuthActionTypes.SET_PROFILE_INFO, data: data });
const setInitialState = (data: { redirectRoute: string | undefined }) => ({ type: AuthActionTypes.SET_INITIAL_STATE, data: data });
const getProfileClientInfo = () => ({ type: AuthActionTypes.GET_PROFILE_CLIENT_INFO });
const setSex = (data: { sex: string }) => ({ type: AuthActionTypes.SET_SEX, data: data });
const setFirstName = (data: { firstName: string }) => ({ type: AuthActionTypes.SET_FIRST_NAME, data: data });
const setLastName = (data: { lastName: string }) => ({ type: AuthActionTypes.SET_LAST_NAME, data: data });
const setNationalId = (data: { nationalId: string }) => ({ type: AuthActionTypes.SET_NATIONAL_ID, data: data });
const checkInfoValidationError = () => ({ type: AuthActionTypes.CHECK_INFO_VALIDATION });
const setHasCallbackFunction = () => ({ type: AuthActionTypes.SET_HAS_CALLBACK_FUNCTION });
const checkSmsCodeAndLogin = (data: { verifyCode: string | number }) => ({ type: AuthActionTypes.CHECK_SMS_CODE_AND_LOGIN, data: data });
const completeClientProfile = () => ({ type: AuthActionTypes.COMPLETE_CLIENT_PROFILE });
export const AuthActions = {
  getClientInfo: getClientInfo,
  saveToken: saveToken,
  saveUser: saveUser,
  checkVerifyCode: checkVerifyCode,
  sendVerificationCode: sendVerificationCode,
  logout: logout,
  setClientMobile: setClientMobile,
  setMobileValidation: setMobileValidation,
  setValidationCode: setValidationCode,
  setCountDownOver: setCountDownOver,
  setCountDownReset: setCountDownReset,
  setLoginModal: setLoginModal,
  setRedirectRoute: setRedirectRoute,
  setCompleteProfileModal: setCompleteProfileModal,
  setConfirmLoading: setConfirmLoading,
  editClientProfile: editClientProfile,
  getProvincesList: getProvincesList,
  setProfileInfo: setProfileInfo,
  setInitialState: setInitialState,
  getProfileClientInfo: getProfileClientInfo,
  setSex: setSex,
  setFirstName: setFirstName,
  setLastName: setLastName,
  setNationalId: setNationalId,
  checkInfoValidationError: checkInfoValidationError,
  setHasCallbackFunction: setHasCallbackFunction,
  checkSmsCodeAndLogin: checkSmsCodeAndLogin,
  completeClientProfile: completeClientProfile,
};
